export enum OSName {
    IOS = "iOS",
}
